import React from "react"

import {
  Breadcrumb,
  Button,
  Grid,
  Header,
  Image,
  Segment,
  Transition,
} from "semantic-ui-react"
import { Link } from "gatsby"
import { capitalize } from "../../utils/string"

const ArtistDetail = ({ artist }) => {
  const dates = artist => {
    if (!artist) return ""
    const { birth_year, death_year, nationality } = artist
    if (!birth_year && !death_year && !nationality) return ""

    var text = ""

    if (birth_year && death_year) {
      text = `${birth_year} - ${death_year}`
    } else if (birth_year) {
      text = `Born ${birth_year}`
    } else if (death_year) {
      text = `Died ${death_year}`
    }

    if (text.length > 0 && nationality) {
      text += " \u2022 "
    }

    if (nationality) {
      text += capitalize(nationality)
    }

    return text
  }

  return (
    <Grid stackable>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Segment basic>
            <Breadcrumb>
              <Breadcrumb.Section as={Link} to={"/"} content={"Home"} />
              <Breadcrumb.Divider />
              <Breadcrumb.Section
                as={Link}
                to={"/artist"}
                content={"Artists"}
              />
              <Breadcrumb.Divider />
              <Breadcrumb.Section active content={artist && artist.name} />
            </Breadcrumb>
          </Segment>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          <Transition.Group
            basic
            as={Segment}
            animation={"fade down"}
            duration={600}
            visible={artist}
          >
            {artist && (
              <Header
                size="huge"
                content={artist.name}
                subheader={dates(artist)}
              />
            )}
          </Transition.Group>
          <Transition.Group
            animation={"fade up"}
            duration={600}
            visible={artist}
          >
            {artist && (
              <Segment>
                <>{artist.biography}</>
              </Segment>
            )}
            {
              <Segment basic>
                <Header
                  size={"large"}
                  content={"Learn More"}
                  subheader={"Sign up for a FREE account today!"}
                  textAlign={"center"}
                />
                <Button
                  primary
                  fluid
                  size={"huge"}
                  content={"Sign Up"}
                  as={Link}
                  to={"https://app.artcollection.io/register"}
                />
              </Segment>
            }
          </Transition.Group>
        </Grid.Column>
        <Grid.Column width={8}>
          <Transition.Group
            style={{ maxHeight: "40em" }}
            as={Image}
            animation={"fade left"}
            duration={600}
            visible={artist}
            centered
            src={artist && artist.image_url}
          />
          <Transition.Group
            basic
            as={Segment}
            animation={"fade up"}
            duration={600}
            visible={artist}
          >
            <div style={{ textAlign: "center", marginTop: "1em" }}>
              {artist && artist.website_url && (
                <Button
                  basic
                  icon={"globe"}
                  labelPosition={"left"}
                  content={"View Website"}
                  as="a"
                  href={artist.website_url}
                  rel="noopener noreferrer"
                  target="_blank"
                />
              )}
            </div>
          </Transition.Group>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

export default ArtistDetail
